import { EventName, Sound, EventsWithoutPayload } from 'types';
import EventsManager from 'managers/events.manager';
import { SFX_CLICK_FILE } from 'constants/audio';

const SOUNDS: Record<string, Partial<Sound>> = {
  click: { url: SFX_CLICK_FILE, volume: 100 },
  pickup: { url: 'PickUpItem', volume: 100 },
  drop: { url: 'DropItem', volume: 100 },
  alreadymixed: { url: 'AlreadyMixed', volume: 400 },
  clone: { url: 'CloneItem', volume: 150 },
  failed: { url: 'FailedToMix', volume: 80 },
  remove: { url: 'RemoveItem', volume: 80 },
  charge: { url: 'ChargeUp', volume: 10 },
  pop: { url: 'PopUp', volume: 30 },
};

type SoundNames = keyof typeof SOUNDS;
const TRIGGERS: Partial<Record<EventName, SoundNames>> = {
  DRAG_START: 'pickup',
  ELEMENT_DROP: 'drop',
  ELEMENT_CLONE: 'clone',
  ELEMENT_DESTROY: 'remove',
  MIX_MIXED: 'alreadymixed',
  MIX_FAIL: 'failed',
  MIX_NEW: 'charge',
  ANIMATION_NEW_POP: 'pop',
  BUTTON_CLICK: 'click',

  // WORKSPACE_CLEAR: 'drop',
  // WORKSPACE_REVERT: 'drop',
};

class SfxManager {
  public play: (name: string) => void;

  constructor(play: (name: string) => void) {
    this.play = play;
    this.initTriggersListeners();
  }

  private initTriggersListeners() {
    Object.entries(TRIGGERS)
      .forEach(([event, sound]) => EventsManager.on(event as EventsWithoutPayload, () => this.play(sound!)));
  }

  get sounds() {
    return SOUNDS;
  }
}

export default SfxManager;
